import React from "react";
import PropTypes from "prop-types";
import Page from "app/pages/.shared/Page/Page";
import CenteredLogoBlock from "app/pages/StaticPage/CenteredLogoBlock/CenteredLogoBlock";
import { STATIC_PAGE_BLOCKS } from "app/constants";
import Separator from "app/pages/.shared/Separator";
import PhotoArticles from "app/pages/StaticPage/PhotoArticle/PhotoArticles";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import "./StaticPage.scss";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";

const StaticPage = ({ blocks = [], title, resolution }) => {
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	return (
		<div className="static-page">
			{blocks.length > 0 ? (
				<Page title={title}>
					{blocks.map((block, index) => {
						let blockComponent;
						if (block._type === STATIC_PAGE_BLOCKS.CENTERED_LOGO_BLOCK) {
							blockComponent = (
								<CenteredLogoBlock
									title={block.title}
									text={block.text}
									image={block.image}
									color={block.color?.hex}
									cta={block.cta}
								/>
							);
						} else if (block._type === STATIC_PAGE_BLOCKS.PHOTO_ARTICLES) {
							blockComponent = (
								<PhotoArticles
									title={block.title}
									articles={block.articles}
									isMobile={isMobile}
								/>
							);
						}
						return (
							blockComponent && (
								<div className="static-page__item" key={index}>
									{index > 0 && <Separator design="middle" />}
									{blockComponent}
								</div>
							)
						);
					})}
				</Page>
			) : (
				<Page>
					<div className="static-page__placeholder">
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
					</div>
				</Page>
			)}
		</div>
	);
};

StaticPage.propTypes = {
	blocks: PropTypes.array,
	title: PropTypes.string,
	resolution: resolutionPropType,
};

export default React.memo(StaticPage);
